import OrgchartItem from './orgchart-item.element.js';

export default OrgchartItem;

OrgchartItem.define('wje-orgchart-item', OrgchartItem);
